/* byChapters — Find Your Chapter quiz (sections/bc-find-your-chapter.liquid).
 * The kit list is the JSON in #fyc-data, which the section emits from the store's collections and nook metafields,
 * so the quiz reads the same fields as the kit pages. Matching: the chosen world first (filtered by form), nearest
 * difficulty, then topped up by difficulty from other worlds. Focus moves to each new question and to the result
 * heading, the step count is a live region, and Start again clears the previous answers. */
(function(){
var T={"libraries": ["Libraries & Bookshops", "/collections/libraries-bookshops"], "shops": ["Shops & Cafés", "/collections/shops-cafes"], "gardens": ["Cottages & Gardens", "/collections/cottages-gardens"], "fantasy": ["Fantasy & Gothic", "/collections/fantasy-gothic"], "museums": ["Museums & Curiosities", "/collections/museums-curiosities"]};
var order={Beginner:0,Intermediate:1,Advanced:2};
var ICO={nook:'<svg viewBox="0 0 24 24"><path d="M4 4h3v16H4zM8 4h3v16H8z"/><path d="M13 5.2l3-.8 4 15.4-3 .8z"/></svg>',house:'<svg viewBox="0 0 24 24"><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/></svg>'};
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
function init(){
 var root=document.getElementById('fyc');
 if(!root||root.hasAttribute('data-fyc-ready'))return;
 var stage=document.getElementById('fyc-stage'),res=document.getElementById('fyc-res');
 if(!stage||!res)return;
 root.setAttribute('data-fyc-ready','');
 var count=document.getElementById('fyc-count'),title=document.getElementById('fyc-title'),note=document.getElementById('fyc-note'),coll=document.getElementById('fyc-coll'),grid=document.getElementById('fyc-grid');
 var K=[],data=document.getElementById('fyc-data'),a={};
 try{K=JSON.parse(data?data.textContent:'[]')||[];}catch(err){K=[];}
 function keepInView(){
  // Only nudge the page if the current question has scrolled out of sight; never push it down.
  var hdr=document.querySelector('header-component, .header, header');
  var off=12+(hdr&&getComputedStyle(hdr).position!=='static'?Math.max(0,hdr.getBoundingClientRect().bottom):0);
  var tgt=res.classList.contains('on')?res:stage;
  var top=tgt.getBoundingClientRect().top;
  if(top<off){window.scrollTo({top:window.pageYOffset+top-off-56,behavior:'instant'});}
 }
 function show(n){
  var done=n>3,active=null;
  stage.classList.toggle('done',done);res.classList.toggle('on',done);
  stage.querySelectorAll('.fyc-step').forEach(function(s){var on=s.getAttribute('data-step')==String(n);s.classList.toggle('on',on);if(on){active=s;s.removeAttribute('aria-hidden');}else{s.setAttribute('aria-hidden','true');}});
  root.querySelectorAll('.fyc-prog i').forEach(function(b,i){b.classList.toggle('on',i<Math.min(n,3));});
  if(count)count.textContent=done?'Your picks':'Step '+n+' of 3';
  // Keyboard and screen-reader users land on the new question (or the result heading) instead of <body>.
  var focusTo=done?title:(active&&active.querySelector('.fyc-q'));
  if(focusTo)focusTo.focus({preventScroll:true});
  keepInView();
 }
 function result(){
  var th=T[a.w];
  if(!th){show(1);return;}
  var pool=K.filter(function(k){return k.w===a.w&&(a.f==='any'||k.f===a.f);});
  if(!pool.length)pool=K.filter(function(k){return k.w===a.w;});
  pool.sort(function(x,y){return Math.abs(order[x.d]-order[a.d])-Math.abs(order[y.d]-order[a.d]);});
  var picks=pool.slice(0,3);
  if(picks.length<3){K.filter(function(k){return picks.indexOf(k)<0&&k.d===a.d&&(a.f==='any'||k.f===a.f);}).slice(0,3-picks.length).forEach(function(k){picks.push(k);});}
  if(title)title.textContent='Your chapter: '+th[0];
  var exact=picks.filter(function(k){return k.d===a.d;}).length;
  if(note)note.textContent=exact?'These fit the time you have and the shelf they\'re going on.':'Nothing in this world is quite that length yet, so these are the closest fits.';
  if(coll){coll.href=th[1];coll.textContent='See all '+th[0];}
  if(grid)grid.innerHTML=picks.map(function(k){return '<a class="fyc-card" href="/products/'+esc(k.h)+'">'+(k.i?'<img src="'+esc(k.i)+'" srcset="'+esc(k.i.replace('width=600','width=300'))+' 300w, '+esc(k.i)+' 600w" sizes="(min-width: 768px) 300px, 45vw" alt="" width="600" height="600" loading="lazy" decoding="async">':'')+'<b>'+esc(k.t)+'</b>'+(k.g?'<small>'+esc(k.g)+'</small>':'')+'<em>'+(ICO[k.f]||'')+esc(k.d)+' · '+(k.f==='nook'?'Book nook':'Miniature house')+(k.b?' · '+esc(k.b):'')+'</em>'+(k.p?'<span class="fyc-card__price">'+esc(k.p)+'</span>':'')+'</a>';}).join('');
  show(4);
 }
 root.addEventListener('click',function(e){
  var o=e.target.closest('.fyc-opt');
  if(o){e.preventDefault();var st=o.closest('.fyc-step');if(!st)return;st.querySelectorAll('.fyc-opt').forEach(function(x){x.classList.toggle('sel',x===o);});a[o.getAttribute('data-k')]=o.getAttribute('data-v');var s=st.getAttribute('data-step');if(s==='3'){result();}else{show(+s+1);}return;}
  var b=e.target.closest('.fyc-back');
  if(b){
   e.preventDefault();
   // Start again (the button inside the result) forgets the previous answers; Back keeps them highlighted.
   if(b.closest('.fyc-res')){a={};root.querySelectorAll('.fyc-opt.sel').forEach(function(x){x.classList.remove('sel');});}
   show(+b.getAttribute('data-back'));
  }
 });
}
init();
document.addEventListener('shopify:section:load',init);
})();

/* Browse-all shelf (3 Oct 2026): the page now leads with every kit in a filterable grid built from the same
 * #fyc-data the quiz reads, and the quiz itself sits behind the "Take the 30-second quiz" toggle. In-stock kits
 * come first, then pre-orders, then anything sold out (dimmed but still clickable). */
(function(){
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
function init(){
 var grid=document.getElementById('fyca-grid');
 if(!grid||grid.hasAttribute('data-ready'))return;
 var K=[],data=document.getElementById('fyc-data');
 try{K=JSON.parse(data?data.textContent:'[]')||[];}catch(err){K=[];}
 if(!K.length)return;
 grid.setAttribute('data-ready','');
 var empty=document.getElementById('fyca-empty');
 if(empty)empty.setAttribute('role','status');
 // The section owns the grid markup; the announcer that reads out filter results is this script's, so it's created here.
 var count=document.createElement('p');
 count.className='visually-hidden';
 count.setAttribute('role','status');
 grid.insertAdjacentElement('afterend',count);
 var state={w:'all',f:'all'};
 function isPre(k){return (k.po||'').indexOf('preorder')>-1;}
 function rank(k){if(k.av&&!isPre(k))return 0;if(isPre(k))return 1;return 2;}
 function badge(k){if(isPre(k))return '<i class="fyc-flag">Pre-order</i>';if(!k.av)return '<i class="fyc-flag fyc-flag--out">Sold out</i>';return '';}
 function card(k){
  var out=!k.av&&!isPre(k);
  return '<a class="fyc-card'+(out?' is-out':'')+'" href="/products/'+esc(k.h)+'">'+badge(k)+(k.i?'<img src="'+esc(k.i)+'" srcset="'+esc(k.i.replace('width=600','width=300'))+' 300w, '+esc(k.i)+' 600w" sizes="(min-width: 768px) 300px, 45vw" alt="" width="600" height="600" loading="lazy" decoding="async">':'')+'<b>'+esc(k.t)+'</b>'+(k.g?'<small>'+esc(k.g)+'</small>':'')+'<em>'+esc(k.d)+' · '+(k.f==='nook'?'Book nook':'Miniature house')+(k.b?' · '+esc(k.b):'')+'</em>'+(k.p?'<span class="fyc-card__price">'+esc(k.p)+'</span>':'')+'</a>';
 }
 function render(){
  var out=K.filter(function(k){return (state.w==='all'||k.w===state.w)&&(state.f==='all'||k.f===state.f);});
  out=out.slice().sort(function(x,y){return rank(x)-rank(y);});
  grid.innerHTML=out.map(card).join('');
  if(empty)empty.hidden=out.length>0;
  count.textContent=out.length+(out.length===1?' kit shown':' kits shown');
 }
 Array.prototype.forEach.call(document.querySelectorAll('.fyca-chip'),function(ch){
  ch.addEventListener('click',function(){
   var k=ch.getAttribute('data-fk');
   state[k]=ch.getAttribute('data-fv');
   Array.prototype.forEach.call(document.querySelectorAll('.fyca-chip[data-fk="'+k+'"]'),function(x){
    var on=x===ch;x.classList.toggle('on',on);x.setAttribute('aria-pressed',on?'true':'false');
   });
   render();
  });
 });
 var open=document.getElementById('fyc-open'),wrap=document.getElementById('fyc-wrap');
 if(open&&wrap){
  open.addEventListener('click',function(){
   var show=wrap.hidden;
   wrap.hidden=!show;
   open.setAttribute('aria-expanded',show?'true':'false');
   open.textContent=show?'Hide the quiz':'Not sure? Take the 30-second quiz';
   if(show){
    var q=wrap.querySelector('.fyc-res.on h2')||wrap.querySelector('.fyc-step.on .fyc-q');
    wrap.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    if(q)q.focus({preventScroll:true});
   }
  });
 }
 render();
}
init();
document.addEventListener('shopify:section:load',init);
})();
